import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from 'react-redux'
import Dialog from "@material-ui/core/Dialog";
import { DialogContentWithCards } from "../components/DialogContent";
import { NewDialogTitle } from "../components/NewDialogTitle";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { PaperCard } from "../components/PaperCard";
import { SelectInput } from "../components/SelectInput";
import SelectOrganization from "../containers/SelectOrganization";
import MaterialTable from "material-table";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Checkbox from '@material-ui/core/Checkbox';
import VisibilityOnIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import GetAppIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import MultiInputTextField from '../components/MultiInputTextField';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { languageOptions, timeZoneOptions } from '../utils/deviceGroupOptions';
import { db } from "../firebase/firebase";
import { NewTextInput } from "../components/NewTextInput";
import { currentUserIsRole, getCurrentUserOrganizationRef } from "../redux/actions/utils";
import { saveDeviceGroup } from "../redux/actions/deviceGroupActions";
import { generateRegistrationCode } from '../utils/deviceGroupUtils';
import { ShowHide } from '../components/ShowHide';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { AddNewButton } from "../components/AddNewButton";
import { API_KEYS, createInfoUrl } from "../utils/routes";
import { addApiKey, deleteApiKey, updateApiKey } from "../redux/actions/apiKeyActions";
import { Link } from "react-router-dom";
import { isCurrentUserAdmin } from "../utils/userRoles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles(theme => ({
    pageTitle: {
        fontWeight: "bold",
        fontSize: "1.6em",
        marginBottom: theme.spacing(2)
    },
    appVersionRow: {
        backgroundColor: theme.palette.background.default
    },
    appVersionCell: {
        paddingTop: 4,
        paddingBottom: 0
    },
    link: {
        color: theme.palette.info.main,
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: theme.palette.hoverBG,
        }
    },
    pageSubTitle: {
        marginTop: theme.spacing(1)
    },
    dialog: {
        maxWidth: 720
    },
    dialogText: {
        marginBottom: theme.spacing(2)
    },
    apiCredential: {
        maxWidth: 340,
        wordBreak: 'break-word'
    },
    apiReferenceContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    }
}));

export const ApiKeysPage = ({ history }) => {
    const classes = useStyles();
    const apiKeys = useSelector(state => state.data.apiKeys);
    const [newApiKeyData, setNewApiKeyData] = useState({ open: false });
    let onAddNewClick = async () => {
        setNewApiKeyData({ open: true });
        let result = await addApiKey({ name: `API Key - ${(new Date()).toGMTString()}` });
        setNewApiKeyData({ open: true, data: result.data });
        // console.log("RESULT", result);
    };

    let columns = [
        {
            title: 'Name',
            field: 'name',
        },
        {
            title: 'Key ID',
            field: 'apiKeyId',
            editable: false
        }
    ]
    let data = _.map(Object.values(apiKeys), o => _.pick(o, ['name', 'apiKeyId']));
    let canEditApiKeys = isCurrentUserAdmin();
    let onClose = () => setNewApiKeyData({ open: false });
    return (
        <div>
            <Dialog maxWidth="lg" scroll="body" onClose={onClose} open={newApiKeyData.open} >
                <NewDialogTitle
                    onCancel={onClose}
                    saveAvaliable={false}
                    caption=""
                    darkBg
                >
                    {"New API Key"}
                </NewDialogTitle>
                <DialogContentWithCards className={classes.dialog}>
                    <Typography variant="body1" className={classes.dialogText}><b>STOP!</b> Store these API Key credentials in a safe location. <i>You will have to generate a new API Key if you lose your API Key Secret</i>.</Typography>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableBody>
                                <TableRow>
                                    <TableCell><b>API Key ID</b></TableCell>
                                    <TableCell className={classes.apiCredential}>{newApiKeyData.data ? newApiKeyData.data.apiKeyId : <CircularProgress size={26} />}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><b>API Key Secret</b></TableCell>
                                    <TableCell className={classes.apiCredential}>{newApiKeyData.data ? newApiKeyData.data.apiKeySecret : <CircularProgress size={26} />}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContentWithCards>
            </Dialog>

            <Grid container justify="space-between">
                <Grid item xs={12}>
                    <Typography variant="h5" className={classes.pageTitle}>
                        API Keys
                        <AddNewButton onClick={onAddNewClick} title={"New API Key"} />
                    </Typography>
                    <div className={classes.apiReferenceContainer}>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                                <Typography>REST API Reference</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{ width: '100%' }}>
                                    <Typography variant="body2" className={classes.pageSubTitle}>The Mighty MDM API provides a RESTful way to access your MDM data.</Typography>
                                    <br />
                                    <Typography variant="body2">To access the REST API, you must a send an HTTPS request with the header: <code>Authorization: Basic <i>&lt;encoded_credentials&gt;</i></code></Typography>
                                    <br />
                                    <Typography variant="body2">To create the <code><i>&lt;encoded_credentials&gt;</i></code>, you must Base64 encode the following string: <code><i>&lt;api_key_id&gt;</i>:<i>&lt;api_key_secret&gt;</i></code></Typography>
                                    <br />
                                    <br />
                                    <Typography variant="body1"><b>Available endpoints:</b></Typography>
                                    <Typography variant="caption">(Each endpoint must be accessed using HTTPS and a valid auth header)</Typography>
                                    <br />
                                    <br />
                                    <div style={{ marginLeft: 20 }}>
                                        <Typography variant="body2"><b>GET</b> /api/v1/devices</Typography>
                                        <div style={{ marginLeft: 20 }}>
                                            <Typography variant="body2">Response: JSON array of all device data</Typography>
                                            <Typography variant="body2">Example: <code>curl -D- -u API_KEY_ID:API_KEY_SECRET -X GET https://dashboard.mightymdm.com/api/v1/devices</code></Typography>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </Grid>
            </Grid>

            <Paper>
                <MaterialTable
                    title=""
                    columns={columns}
                    data={data}
                    localization={{
                        body: {
                            editRow: {
                                deleteText: 'Are you sure you want to delete this API Key?'
                            }
                        }
                    }}
                    editable={{
                        isEditable: _ => canEditApiKeys,
                        isDeletable: _ => canEditApiKeys,
                        onRowUpdate: async (newData, oldData) => {
                            if (oldData.name !== newData.name) {
                                await updateApiKey({ apiKeyId: oldData.apiKeyId, changes: { name: newData.name } });
                            }
                        },
                        onRowDelete: async (oldData) => {
                            await deleteApiKey({ apiKeyId: oldData.apiKeyId });
                        }
                    }}
                    options={{
                        sorting: true,
                        pageSize: 10,
                        pageSizeOptions: [10],
                        showTitle: false,
                        toolbarButtonAlignment: 'right',
                        draggable: false,
                        emptyRowsWhenPaging: false,
                    }}
                />
            </Paper>
        </div >
    )
};
